import { Area, CartesianGrid, ComposedChart, Line, ResponsiveContainer, XAxis, YAxis, Tooltip } from 'recharts';

export default function SecondaryDetailsChart(props) {
  const { data = [], color = '#DD0D33' } = props;

  const interval = data?.length <= 6 ? '' : data?.length <= 10 ? 2 : parseInt(data?.length / 5);

  return (
    <ResponsiveContainer width={'100%'} height={'100%'}>
      <ComposedChart data={data}>
        <defs>
          <linearGradient id='colorUv' x1='0' y1='0' x2='0' y2='1'>
            <stop offset='5%' stopColor={color} stopOpacity={0.5} />
            <stop offset='95%' stopColor={color} stopOpacity={0} />
          </linearGradient>
        </defs>
        <XAxis dataKey='fullDate' interval={interval} />
        <YAxis />
        <Tooltip
          active={true}
          wrapperStyle={{
            visibility: 'visible',
          }}
          content={<CustomTooltip />}
        />
        <CartesianGrid vertical={false} />
        <Area type='linear' dataKey='price' stroke={color} fillOpacity={1} fill='url(#colorUv)' />
        <Line type='linear' dataKey='price' strokeWidth={2} stroke={color} dot={false} />
      </ComposedChart>
    </ResponsiveContainer>
  );
}
function CustomTooltip({ active, payload, label }) {
  if (active && payload && payload.length) {
    return (
      <div className='custom-tooltip'>
        <p className='label'>{`$${payload[0].value}  ${label}`}</p>
      </div>
    );
  }
}
